/**
 * How Page photos lays photos out in the spreads they print in
 * (docs/design/HANDOFF.md, "Page photos grid shows facing pages").
 *
 * The first spread is the inside front cover, shown as the dedication page
 * whether or not the book has one yet (decided 2026-10-23), beside photo 1; then 2 and 3,
 * 4 and 5, ... Under 20 photos the "Add photos" tile takes the next slot. A
 * spread left half-filled ends with a blank page (photo 20 faces one).
 *
 * With all 20 photos that last page is the inside back cover ({ kind: "insideBack" }).
 *
 * Returns [{ label, slots: [{ kind: "photo", index } | { kind: "dedication" } |
 * { kind: "blank" } | { kind: "insideBack" } | { kind: "add" }] }], two slots per spread.
 */
export const BOOK_PAGES = 20;

export function buildPhotoSpreads({ count, showAdd = true }) {
  const slots = [{ kind: "dedication" }];
  for (let index = 0; index < count; index += 1) slots.push({ kind: "photo", index });
  if (showAdd && count < BOOK_PAGES) slots.push({ kind: "add" });
  if (slots.length % 2) slots.push({ kind: count >= BOOK_PAGES ? "insideBack" : "blank" });

  const spreads = [];
  for (let i = 0; i < slots.length; i += 2) {
    const [left, right] = [slots[i], slots[i + 1]];
    let label;
    if (i === 0) label = "Dedication and page 1";
    else if ((right.kind === "blank" || right.kind === "insideBack") && left.kind === "photo") label = `Page ${i}`;
    else label = `Pages ${i} and ${i + 1}`;
    spreads.push({ label, slots: [left, right] });
  }
  return spreads;
}
